import { GUIBase } from './gui_base';
export class DebugGUI extends GUIBase {
    constructor(debug) {
        super();
        this.debug = debug;
        this.gui = GUIBase.createFolder('Debug');
        this.gui.add(this.debug, 'fps').name('FPS Counter');
        this.gui.add(this.debug, 'trackables').name('Tracking Data');
        this.gui.add(this.debug, 'allowFaceToFaceMode').name('Allow Face To Face Mode');
    }
}
//# sourceMappingURL=gui_debug.js.map